/**
 * 题目的默认值
 */
export default {
  id: '',
  title: '',
  titleAlias: '',
  type: '',
  images: [],
  text: '',
  textPrefix: '',
  jumpTargetId: '',
  referIds: [],
  delay: '0',
  needEvidence: true,
  localFile: false,
  clarity: '0',
  minDuration: '0',
  evidenceQuality: '2',
  evidenceType: 'photo',
  imageRecognitionType: [],
  reportedTablesAssociationStepId: '',
  takePhotoAuxiliaryLine: 0,
  takePhotoScene: 0, // 2022-07-13 新增拍照场景（陈列分组拍摄），是 forcePanorama 字段的替代
  allowReusePhoto: false,
  allowCrossSubjectRecord: false,
  inputType: 'text',
  inputMin: null,
  inputMax: null,
  guideText: '',
  guideVideo: [],
  guideAudio: [],
  options: [],
  dataLabel: '',
  forceGuideVideo: false,
  forceGuideAudio: false,
  auditText: '',
  intelligentCall: false,
  keyin_ids: [],
  ondutyCheck: false,
  throughRecordKeyQuestion: false,
  allow_media_download: 2,
  allow_screen_capture: 2,
}



// WEBPACK FOOTER //
// ./src/views/question-editor/format/convert-fields/question.js